var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.4055C13.524 11.8997 12.4927 10.5445 12.5754 8.41907C12.6249 7.15969 11.944 6.49525 11.2499 6.14156C10.3739 5.69533 9.3261 5.69533 8.45016 6.14156C7.75601 6.49525 7.07508 7.15969 7.12466 8.41907C7.21061 10.5478 6.176 11.8997 5.70001 12.4055",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1938 12.2476C14.281 12.3547 14.2649 12.5122 14.1579 12.5994C12.974 13.5637 11.4057 14.038 9.84911 14.0376C8.29256 14.0372 6.72587 13.562 5.54532 12.5993C5.43831 12.512 5.42231 12.3545 5.50957 12.2475C5.59684 12.1405 5.75432 12.1245 5.86132 12.2118C6.93839 13.0902 8.38792 13.5372 9.84925 13.5376C11.3106 13.538 12.7617 13.0918 13.8421 12.2117C13.9492 12.1245 14.1066 12.1406 14.1938 12.2476Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9162 14.2119C9.03397 14.2119 9.12945 14.3074 9.12945 14.4252C9.12945 14.6694 9.40356 14.949 9.85163 14.949C10.2997 14.949 10.5738 14.6694 10.5738 14.4252C10.5738 14.3074 10.6693 14.2119 10.7871 14.2119C10.9049 14.2119 11.0003 14.3074 11.0003 14.4252C11.0003 14.9941 10.4349 15.3755 9.85163 15.3755C9.26839 15.3755 8.70294 14.9941 8.70294 14.4252C8.70294 14.3074 8.79842 14.2119 8.9162 14.2119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertas);
export default __webpack_public_path__ + "static/media/alertas.bf587c64f0a02e5fb78c13b5df4fd7f3.svg";
export { ForwardRef as ReactComponent };